module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/secondImage.782940fc.jpg";